import Radio from "backbone.radio";
import { View } from "extensions/marionette";
import loader from "common/helpers/horizontal-loader.jst";
import { FilterBarRedux } from "common/components/filterBar/FilterBar";

import { DashboardContent } from "./dashboardContent";

import template from "./template.jst";

import "./dashboard3.scss";

export const Dashboard3 = View.extend({
    className: "dashboard3",
    template: () => template({
        loader: loader()
    }),
    regions: {
        controls: ".controls-dashboard",
        content: ".content-dashboard .contentWrapper"
    },
    childViewEvents: {
        addWidget() {
            this.getChildView("content").addWidget();
        },
        serialize() {
            this.getChildView("content").serialize();
        }
    },
    
    showContent() {
        this.showChildView("content", new DashboardContent({
            qualifiers: this.getOption("qualifiers")
        }));
    },
    
    showFilters() {
        this.showChildView("controls", <FilterBarRedux
            qualifiers={this.getOption("qualifiers").toString()}
            onChange={(qualifiers) => {
                Radio.channel("dashboard").trigger("navigate", { qualifiers }, this);
            }}
        />);
    },
    
    onRender() {
        this.showFilters();
        this.showContent();
        // Also subscribe to a merchant change
        this.onEntityChange(() => this.showContent());
    }
});
